import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { useQuery } from 'react-query';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { routeMap } from 'router';
import { humanizeRub } from '../../../../utils';
import { apiResponseWrapper } from 'utils/apiResponseWrapper';
import LinkWrapper from 'containers/LinkWrapperContainer';
import Loading from '../../../../components/Loading';
import { useTaxCards } from '../../../NewTaxes/apiHooks/useTaxCards';
import getContactInfo from 'modules/Profile/services/API/getPersonalData';
import { ArmyMeasuresRequestLink } from './ArmyMeasuresRequestLink';
import { MobilizationReportLink } from './MobilizationReportLink';
import { DetailsLink } from './DetailsLink';
import styles from './Home.module.scss';
import { remotePaths } from 'router/routes';

export function ToPayContainer({ hasDebts, accrualIsPresent }) {
  const { isFetching, data: taxesCards } = useTaxCards();

  const { isFetchingContactInfo, data: contactInfo } = useQuery('getContactInfo', async () => {
    return apiResponseWrapper(await getContactInfo());
  });
  const sum = get(taxesCards, 'totalSumToPay');
  const noToPayAmount = +sum === 0;
  const getTitle = () => {
    if (noToPayAmount) {
      return (
        <a href={remotePaths.taxes} className={`white ${styles.noToPayAmount}`}>
          У Вас нет неоплаченных налогов и задолженности
        </a>
      );
    }

    if (hasDebts && !accrualIsPresent) {
      return 'Задолженность: ';
    } else {
      return 'К оплате: ';
    }
  };

  const getPaymentLink = () => {
    if (+sum === 0) {
      return null;
    }

    return (
      <div className="main-page_row">
        <LinkWrapper href={routeMap.taxesPayment} className="button button__orange button__medium">
          Оплатить сейчас
        </LinkWrapper>
      </div>
    );
  };

  const renderWalletLink = () => {
    return (
      <a href={remotePaths.taxes} className="link bold orange">
        {'Вы можете пополнить авансовый кошелек'}
      </a>
    );
  };

  const renderAdditionMessage = () => {
    return accrualIsPresent && hasDebts && +sum !== 0 ? (
      <div className="text-big main-page_add" style={{ color: '#FF7519' }}>
        Внимание! Часть этой суммы является задолженностью, на которую могут начисляться пени.
        Оплатить задолженность, пени или всю сумму налогов Вы можете, нажав кнопку «Оплатить
        сейчас».
      </div>
    ) : null;
  };

  const isArmyMobilized = useSelector((state) => {
    const profile = get(state, 'app.user', Map);
    const profileData = profile.get('data') || {};
    return profileData.get('isArmyMobilized');
  });

  const amount = humanizeRub(sum);
  const [amountWhole, amountFractional] = amount.split('.');
  return (
    <>
      <div className="boo main-page_row main-page_row__main">
        <div className="main-page_info">
          <div className="main-page_title">
            <span
              className={classnames('main-page_title_description', {
                orange: hasDebts && !accrualIsPresent,
              })}
            >
              {getTitle()}
            </span>
            <div className={'boo'}>
              <div className="position-relative w-25 mh-3 H1">
                {isFetching || isFetchingContactInfo ? (
                  <div className=" p-3 m-3">
                    <Loading isLight={true} />
                  </div>
                ) : sum && +sum > 0 ? (
                  <span className="nowrap main-page_title_sum">
                    {amountWhole}
                    <span className="main-page_title_sum_fractional">
                      .{amountFractional}
                      <span className="icon-rouble" />
                    </span>
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {noToPayAmount ? (
          <div className="d-flex flex-column">
            {!isArmyMobilized && (
              <MobilizationReportLink position="top" contactInfo={contactInfo} />
            )}
            {renderWalletLink()}
          </div>
        ) : (
          <div className="main-page_details d-flex flex-column">
            <DetailsLink sum={+sum} />
            {isArmyMobilized ? (
              <ArmyMeasuresRequestLink />
            ) : (
              <MobilizationReportLink position="bottom" contactInfo={contactInfo} />
            )}
          </div>
        )}
        {renderAdditionMessage()}
      </div>
      {getPaymentLink()}
    </>
  );
}

ToPayContainer.propTypes = {
  hasDebts: PropTypes.bool,
  accrualIsPresent: PropTypes.bool,
};
